import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";

var Account = /*#__PURE__*/function () {
  function Account(context) {
    _classCallCheck(this, Account);

    this.context = context;
  }

  _createClass(Account, [{
    key: "getMine",
    value: function getMine() {
      return this.context.http.get('/msvc/v1/accounts/mine');
    }
  }, {
    key: "getMineAddresses",
    value: function getMineAddresses(id) {
      return this.context.http.get("/msvc/v1/accounts/mine/".concat(id, "/addresses"));
    }
  }, {
    key: "getOwnerAddresses",
    value: function getOwnerAddresses(id) {
      return this.context.http.get("/msvc/v1/accounts/items/".concat(id, "/addresses"));
    }
  }, {
    key: "getAccountNameByAccountId",
    value: function getAccountNameByAccountId(id) {
      return this.context.http.get("/msvc/v1/accounts/items/".concat(id));
    }
  }, {
    key: "getAccountNameByCollaboratorIds",
    value: function getAccountNameByCollaboratorIds(onlyIds) {
      return this.context.http.get("/msvc/v1/accounts/items?onlyIds=".concat(onlyIds, "&limit=20&offset=0"));
    }
  }, {
    key: "getPartnerAccounts",
    value: function getPartnerAccounts(params) {
      return this.context.http.get('/msvc/v1/accounts/items', params);
    }
  }]);

  return Account;
}();

export default Account;